import { render, staticRenderFns } from "./dategoods.vue?vue&type=template&id=9509842c&scoped=true&"
import script from "./dategoods.vue?vue&type=script&lang=js&"
export * from "./dategoods.vue?vue&type=script&lang=js&"
import style0 from "./dategoods.vue?vue&type=style&index=0&id=9509842c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9509842c",
  null
  
)

export default component.exports